import { ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';

import { SubscriptionStatus } from '@vi-iot/client';

import { AuthStore, BookingSubscription } from '@store';

@Component({
  selector: 'app-flat-rate-status-tiles',
  templateUrl: './flat-rate-status-tiles.component.html',
  styleUrls: ['./flat-rate-status-tiles.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FlatRateStatusTilesComponent implements OnChanges {
  @Input() subscription: BookingSubscription;
  @Input() isActiveSubscription: boolean;
  @Input() isAnyActiveOrCancelledSubscription: boolean;

  readonly subscriptionStatus = SubscriptionStatus;
  dateLabel: string;

  constructor(public authStore: AuthStore, private router: Router) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.subscription.currentValue?.status !== changes.subscription.previousValue?.status) {
      this.dateLabel = this.getDateLabel();
    }
  }

  onRenewSubscription(): void {
    this.router.navigate(['/booking']);
  }

  private getDateLabel(): string {
    switch (this.subscription.status?.toLowerCase()) {
      case SubscriptionStatus.active:
        return '+BOOKING.OVERVIEW.FLATRATE.AUTOMATIC_EXTENSION';

      case SubscriptionStatus.canceled:
        return '+BOOKING.OVERVIEW.SUBSCRIPTION.EXPIRES_ON';

      case SubscriptionStatus.expired:
        return '+BOOKING.OVERVIEW.FLATRATE.EXPIRED_ON';
    }
  }
}
